import React, { useEffect } from "react";
import { Table } from "antd";
import { useModel } from "../../models";
import { goPage } from "../layout/pageDefinition";
import { useHistory } from "react-router";
import { decoder } from "../../utils/decoder"
export default function () {
    const history = useHistory();
    const [{ saleStatusDict }, { getCustomerTypeDict }] = useModel("cmDict");


    const [
        { searchParam, documentList, documentStatistic, documentPageInfo, selectedDocumentRowKeys },
        { loadDocumentList, exportSo, setSelectedDocumentRowKeys, setDocumentMaterialList, loadSo }
    ] = useModel("saleSo");
    const [{ userInfo }, { }] = useModel("global")

    const columns = [
        {
            title: '销售单号',
            dataIndex: 'saleCode',
            render: text => <span>{text}</span>,
        },
        {
            title: '客户名称',
            dataIndex: 'customerName',
            align: 'left',
        },
        {
            title: '销售日期',
            dataIndex: 'createTime',
        },
        {
            title: '未出库数量',
            dataIndex: 'noIssuedNum',
        },
        {
            title: '单据状态',
            dataIndex: 'orderStatusName',
            // render: text => <span>{decoder(saleStatusDict,text)}</span>,
        }
    ];
    const userType = {
        "scm-cw": "017002",
        "scm-ywy": "017001",
        "scm-kg": "017002,017003",
        "gongyingliang": ""
    }
    useEffect(() => {
        // const {roleDetails} = userInfo
        // const {pageSize, pageNum} = documentPageInfo;
        // let filterItem = null
        // // console.log(roleDetails)
        //  Object.keys(userType).forEach(key=>{
        //     roleDetails.forEach(item2=>{
        //         if(item2.roleCode==key){
        //             return filterItem = item2.roleCode
        //         }
        //     })
        // })
        let data = {
            pageSize: 6,
            pageNum: 1,
            // orderStatus: userType[filterItem]
        };
        loadDocumentList({ showMsg: false, data });
    }, []);
    return <Table
        columns={columns}
        dataSource={documentList}
        bordered
        pagination={false}
        onRow={record => {
            return {
                onClick: event => {
                    if (selectedDocumentRowKeys.length > 0 && selectedDocumentRowKeys[0] === record.key) {
                        setSelectedDocumentRowKeys([]);
                    } else {
                        setSelectedDocumentRowKeys([record.key]);
                    }
                    loadSo({ showMsg: false, data: record.key }).then(() => {
                        goPage(history, "3-2-1");
                    });
                },
            }
        }}
    // rowSelection={{
    //     // type: "radio",
    //     onChange: (selectedRowKeys) => {
    //         setSelectedDocumentRowKeys(selectedRowKeys);
    //     },
    //     selectedRowKeys: selectedDocumentRowKeys
    // }}
    />
};